var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('symbol',{attrs:{"id":(_vm.prefix + "blank"),"viewBox":"0 0 16 16"}})}
var staticRenderFns = []

export { render, staticRenderFns }